function setupDevTools() {
  window.enableTunnelFeature = function (secret) {
    if (secret === "sf-tunnel") {
      sessionStorage.setItem("tunnelFeatureEnabled", "true");
      console.log(
        "%c🚀 Tunnel Management UI Unlocked!",
        "color: #4CAF50; font-size: 16px; font-weight: bold;"
      );

      window.location.reload();
      return "Feature enabled. Page will reload.";
    } else {
      console.error("Incorrect secret.");
      return "Incorrect secret.";
    }
  };

  window.disableTunnelFeature = function () {
    sessionStorage.removeItem("tunnelFeatureEnabled");
    console.log(
      "%c🔒 Tunnel Management UI Locked.",
      "color: #f44336; font-size: 16px; font-weight: bold;"
    );
    window.location.reload();
    return "Feature disabled. Page will reload.";
  };
}

export {setupDevTools};
